// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/f0ab614b/" + chunkId + "." + __webpack_require__.h() + ".vf0ab614b.js";
};